import React from "react";

function DailyForecast({ currentLocation, locationName, input, inputCountry }) {
  const dataFunction = (data) => {
    return new Date(data * 1000).toLocaleString("en-in", {
      weekday: "short",
      day: "numeric",
      month: "short",
    });
  };

  return (
    <>
      <div className="mt-5">
        <h4 className="primary-color">
          Daily Forecast in{" "}
          {input && input ? input : locationName && locationName.city},
          {inputCountry && inputCountry
            ? inputCountry
            : locationName && locationName.country_code}
        </h4>
      </div>

      <div className="flex text-center mt-5 space-between">
        {currentLocation &&
          currentLocation.daily.slice(0, 6).map((currentLocation) => (
            <div className="bg-container m-2" key={currentLocation.timezone_offset}>
              <h5 className="pt-3">{dataFunction(currentLocation.dt)}</h5>
              <div className="flex space-evenly align-items-center">
                <div>
                  <div className="flex justify-content-center temp-color">
                    <h4>
                      {currentLocation &&
                        Number(currentLocation.temp.max).toFixed(0)}
                      {/* 34 */}
                      <sup className="temp-color">o</sup>
                    </h4>
                    <h6 className="daily-temp-degree">C</h6>
                  </div>
                </div>
                {currentLocation && (
                  <img
                    src={`http://openweathermap.org/img/wn/${currentLocation.weather[0].icon}@2x.png`}
                    className="daily-forecast-icon"
                  />
                )}
              </div>
              <small>
                {currentLocation && currentLocation.weather[0].description}
              </small>
            </div>
          ))}
      </div>
    </>
  );
}

export default DailyForecast;
